import { memo } from 'react';

import { useAppSelector } from '@/hooks/redux';
import { loginAccounts } from '@/services/accounts';

interface Props {
  children: React.ReactNode;
}

const PrivateRoute = ({ children }: Props) => {
  const user = useAppSelector(store => store.auth.user);

  if (!user) {
    loginAccounts();
    return null;
  }

  return <>{children}</>;
};

export default memo(PrivateRoute);
